import moment from "moment"
import settings from './settings'

const filters = {
    format_float(value) {
        const formatter = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
        return formatter.format(value)
    },

    human_date(date) {
        return moment(date).fromNow()
    },

    local_date(date) {
        return moment(date).format("DD/MM/YYYY")
    },

    as_media(path) {
        return settings.backendMediaUrl + path
    },

    as_css_background(path) {
        return {
            'background-image': 'url(' + settings.backendMediaUrl + path + ')'
        }
    },

    as_css_background_string(path) {
        return 'url(' + settings.backendMediaUrl + path + ')'
    },

    ifempty(text, default_text) {
        let ret = text
        if (text === '') {
            ret = default_text
        }
        return ret
    },

    ellipsis(text, cutoff) {
        cutoff = cutoff || 25
        const keep = 10
        let result
        if (text.length > cutoff) {
            result = text.slice(0, keep) + " ... " + text.slice(-keep)
        } else {
            result = text
        }
        return result
    },

    as_establishment(text) {
        let ret = text
        if (text === "Réponse en cours de rédaction") {
            ret = "Réponse à valider"
        } else if (text === "Classé") {
            ret = "Traité"
        }
        return ret
    },

    round(value, decimals) {
        const intl = new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        })
        return intl.format(value)
    }
}

export default {filters}
